import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import SectoralIndices from '../../pages/markets/component/sectoral-indices';


export const SectorIndicesWithGraphWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <SectoralIndices widget={true} />
    </QueryClientProvider>
  );
};
